module.exports = __webpack_public_path__ + "assets/security-3-7d56ca06c8cad2849e8495f17f2c24f4.svg";